module.exports = __webpack_public_path__ + "media/images/image_sonaeru-1bf3c042a252509369b27194210f2bf3.png";